import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAuth } from 'lib/useAuth';
import logger from 'lib/logger';
import { ApplicationState } from 'store/store';
import { checkinsApi } from '../checkinsApi';

export function useCheckins() {
    const { user } = useAuth();

    const checkinOnOrderLocationSelected = useSelector(
        (state: ApplicationState) => state.settings.settings?.checkins?.checkinOnOrderLocationSelected
    );

    const triggerCheckin = useCallback(
        async (locationId: string): Promise<void> => {
            if (!user || !locationId) {
                return;
            }

            try {
                await checkinsApi.createCheckin({
                    userId: user.id,
                    locationId,
                    type: 'MANUAL',
                    trigger: 'GEO'
                });
            } catch (e) {
                logger.error(e);
            }
        },
        [user]
    );

    return { checkinOnOrderLocationSelected, triggerCheckin };
}
